import styled from 'styled-components';

export const MiddleWrap = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1.6rem;
`;
export const FilterBox = styled.div`
  display: flex;
  color: #8e899f;
`;
export const FilterItem = styled.div`
  display: flex;
  border: 0.1rem solid #2e2b36;
  gap: 0.3rem;
  padding: 0.5rem 1.2rem 0.5rem 0.8rem;
  border-radius: 1.4rem;
`;
export const Container = styled.div`
  padding: 0 2rem;
`;

export const PostingBox = styled.div`
  width: 100%;
  height: 30rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  overflow-y: auto;
  margin-top: 2rem;
`;

export const PortfolioCard = styled.div`
  display: flex;
  gap: 1.8rem;
  align-items: center;
`;

export const ImgBox = styled.div`
  width: 6.4rem;
  height: 6.4rem;
  background-color: #24222a;
  border-radius: 0.8rem;
`;

export const PortfolioInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  align-items: flex-start;
`;
export const CertificationTag = styled.div`
  padding: 0.25rem 0.7rem 0.25rem 0.5rem;
  border-radius: 2.2rem;
  background-color: #1f1e25;
  font-size: 1rem;
  color: #ff8ac2;
  display: flex;
  gap: 0.3rem;
`;

export const PointText = styled.span`
  color: #9170f2;
`;
